import React from "react";

const quote = (value) => `"${String(value ?? "").replaceAll('"', '""')}"`;

export function downloadClientReportCsv(report, businessName) {
  if (!report?.columns?.length || !report?.rows) {
    throw new Error("There is no generated report to export.");
  }

  const lines = [
    [businessName || "Business", report.title || "Financial Report"],
    [report.period || ""],
    [],
    report.columns.map((column) => column.label),
    ...report.rows.map((row) =>
      report.columns.map((column) => row[column.key] ?? ""),
    ),
  ];
  const csv = `\ufeff${lines.map((line) => line.map(quote).join(",")).join("\r\n")}`;
  const url = URL.createObjectURL(new Blob([csv], { type: "text/csv;charset=utf-8" }));
  const link = document.createElement("a");
  link.href = url;
  link.download = `${String(report.title || "Financial_Report").replace(/[^a-z0-9]+/gi, "_")}.csv`;
  link.click();
  URL.revokeObjectURL(url);
}

export default function ClientReportExport({ report, businessName, onExport }) {
  return (
    <button
      type="button"
      onClick={() => (onExport ? onExport() : downloadClientReportCsv(report, businessName))}
      disabled={!report}
      className="rounded-xl bg-slate-900 px-4 py-2 text-xs font-bold text-white transition hover:bg-slate-800 disabled:cursor-not-allowed disabled:opacity-50"
    >
      Export CSV
    </button>
  );
}